'use client';

import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type Context = {
  termsOfServiceAccepted: boolean;
  setTermsOfServiceAccepted: Dispatch<SetStateAction<boolean>>;
  privacyPolicyAccepted: boolean;
  setPrivacyPolicyAccepted: Dispatch<SetStateAction<boolean>>;
};

const LegalTermsContext = createContext<Context | null>(null);

interface Props {
  children: ReactNode;
}

const LegalTermsProvider = ({ children }: Props) => {
  const [termsOfServiceAccepted, setTermsOfServiceAccepted] = useState(false);
  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);

  const value = {
    termsOfServiceAccepted,
    setTermsOfServiceAccepted,
    privacyPolicyAccepted,
    setPrivacyPolicyAccepted,
  };

  return (
    <LegalTermsContext.Provider value={value}>
      {children}
    </LegalTermsContext.Provider>
  );
};

function useLegalTerms() {
  const context = useContext(LegalTermsContext);
  if (!context) throw new Error('useLegals requires a context!');

  return context;
}

export { LegalTermsProvider, useLegalTerms };
